import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyANFw8548q1Rc4PduSOnLfIBkrnv8Tdh7k",
  authDomain: "kwicth-f63f9.firebaseapp.com",
  projectId: "kwicth-f63f9",
  storageBucket: "kwicth-f63f9.appspot.com",
  messagingSenderId: "936178126808",
  appId: "1:936178126808:web:52ad291ce393ac843168445",
};

const app = initializeApp(firebaseConfig);

// Firebase services
const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);

// ✅ Google Login Provider (this was missing)
const googleProvider = new GoogleAuthProvider();

export { db, auth, storage, googleProvider };
